import React from 'react';
import BTN3 from '../../static/media/ckhycsjg.png';
import './Danmaku.css';

const Danmaku = ({ messages = [], lookFriend = () => {} }) => {
  
  if(messages.length === 0){
    return <img style={{ width: '60%', position: 'fixed', left: '20%', top: '40px' }} src={BTN3} alt="" onClick={lookFriend} />
  }

  return (
    <div className="danmaku-container">
      <img style={{ width: '60%', position: 'fixed', left: '20%', top: '40px' }} src={BTN3} alt="" onClick={lookFriend} />
      {messages.map((item, index) => (
        <div
          key={index}
          className="danmaku"
          style={{ marginTop: 2, animationDelay: `${index * 1}s` }}
        >
          <div className='danmaku-item'>
            <img style={{ height: 20, width: 20, display: 'inline-block', borderRadius: 20, marginRight: 4 }} src={item.headPortrait} />{item.messages}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Danmaku;
